import ApiService from './ApiService';

export default class CommissionApi extends ApiService {
    constructor() {
        super('system');
    }

    getCommissions(payload) {
        return this.get('commissions', payload);
    }

    exportFileCommissionExcel(payload) {
        return this.get('commissions/export-excel', payload, { responseType: 'blob' });
    }

    exportFileCommissionPdf(payload) {
        return this.get('commissions/export-pdf', payload, { responseType: 'blob' });
    }

    // #region Monthly owner commission statistics
    getCommissionMonths(payload) {
        return this.get('commissions/statistics', payload);
    }

    // #region info commission adjust
    getCommissionAdjust(payload) {
        return this.get('commissions/adjust', payload);
    }

    postCommissionAdjust(payload) {
        return this.post('commissions/adjust', payload);
    }

    issueInvoiceBill(payload) {
        return this.get('commissions/month/export', payload, { responseType: 'blob' });
    }

    getSalutation(payload) {
        const { userId, ...otherPayload } = payload;
        return this.get(`salutations/${userId}`, otherPayload);
    }

    updateSalutation(payload) {
        return this.post('salutations', payload);
    }
}
